import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
export default Vue.extend({
    name: 'bonusBalanceWidget',
    props: {
        loadError: {
            type: Boolean,
            required: true
        },
        isRetry: {
            type: Boolean,
            required: true
        },
        balance: {
            type: Object,
            required: true
        },
        prices: {
            type: Object,
            required: true
        },
        autopay: {
            type: Boolean,
            required: true
        },
        isAutopayLoaded: {
            type: Boolean,
            required: true
        },
        faqPageUrl: {
            type: String
        }
    },
    computed: {
        lvlBalance() {
            return this.balance.USDT
                .plus(this.balance.BNB.multipliedBy(this.prices.BNB))
                .plus(this.balance.FDUSD.multipliedBy(this.prices.FDUSD))
                .plus(this.balance.USDC.multipliedBy(this.prices.USDC))
                .plus(this.balance.BTC.multipliedBy(this.prices.BTC));
        },
        faqPageTo() {
            const urlObj = new URL(this.faqPageUrl + '#convertation-rules');
            return urlObj.pathname + urlObj.search + urlObj.hash;
        }
    },
    methods: {
        callRulesPopup() {
            const vm = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.info,
                letDefaultClose: true,
                title: vm.$t('bonusesPage.popups.titles.rulesAccruals'),
                content: '',
                slot: {
                    name: 'bonusRulesPopupChunk',
                    data: {
                        showExtended: false
                    }
                },
                actions: [
                    {
                        title: vm.$t('bonusesPage.popups.actions.ok'),
                        isAccent: true,
                        callback() { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        }
    }
});
